import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import SerieService from 'business/cadastro/fiscal/serie/serieService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { createCodeDescriptionObject } from 'helper/formater'

import ModeloDocFiscalService from 'business/cadastro/fiscal/modeloDocFiscal/modeloDocFiscalService'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

export default function Serie() {

    const [service] = useState(() => new SerieService())
    const [modeloDocFiscals, setModeloDocFiscals] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.modelo_doc_fiscal) {
            setModeloDocFiscals([createCodeDescriptionObject(data.modelo_doc_fiscal, 'codigo_modf', 'descricao_modf', true)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadModeloDocFiscals = async () => {
        const modf = new ModeloDocFiscalService()
        await modf.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_modf', 'descricao_modf', true))
            options.push({ codigo_modf: null, descricao_modf: defaultEmptySelection() })
            setModeloDocFiscals(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="sigla_serie" form={form} service={service} type="text" clearString label="Sigla" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="descricao_serie" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="prox_num_serie" form={form} service={service} type="number" label="Próximo número de nota fiscal"
                            minFractionDigits={0}
                            maxFractionDigits={0}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_modf_serie" form={form} type="dropdown2" service={service} label="Modelo de doc. fiscal"
                            optionKey='codigo_modf'
                            optionLabel='descricao_modf'
                            options={modeloDocFiscals}
                            onLoad={loadModeloDocFiscals}
                        />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="ativa_serie" form={form} service={service} type="switch" label="Ativa" />

                    </GridForm>

                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
